import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-neutral-300 hover:text-theatre-gold transition-colors duration-200 border border-white/15 hover:border-theatre-gold/50 px-3 py-2"
      >
        <Globe size={15} />
        <span>{current?.flag} {compact ? current?.code.toUpperCase() : current?.label}</span>
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-2 w-48 max-h-80 overflow-y-auto custom-scroll bg-black/95 backdrop-blur-xl border border-theatre-gold/25 z-[60] py-2"
        >
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-sm transition-colors duration-150 ${
                l.code === lang ? "text-theatre-gold bg-white/5" : "text-neutral-300 hover:bg-white/5 hover:text-white"
              }`}
            >
              <span className="flex items-center gap-3"><span>{l.flag}</span>{l.label}</span>
              {l.code === lang && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
